import { Award, BookOpen, Briefcase, Heart } from "lucide-react";
import { useWebsiteContent } from "@/hooks/useWebsiteContent";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const About = () => {
  const { content } = useWebsiteContent();
  const { ref: sectionRef, isVisible } = useScrollReveal();

  const credentials = [
    { icon: Briefcase, label: "18+ Years Corporate Experience" },
    { icon: BookOpen, label: "MBA & Engineering Degree" },
    { icon: Award, label: "Certified Life Coach" },
    { icon: Heart, label: "Certified Yoga Teacher" },
  ];

  const storyParagraphs = content.about_story?.split("\n\n") || [];

  return (
    <section id="about" className="py-20 md:py-28 bg-background">
      <div ref={sectionRef} className={`max-w-[680px] mx-auto px-4 scroll-reveal ${isVisible ? "is-visible" : ""}`}>
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-foreground tracking-[-0.03em] leading-tight">
            {content.about_name}
          </h2>
          <p className="text-xl md:text-2xl text-muted-foreground mt-3 font-normal">
            {content.about_title}
          </p>
        </div>

        {/* Content */}
        <div className="space-y-5 text-muted-foreground leading-[1.75] text-[17px] text-center mb-14">
          {content.about_intro && <p>{content.about_intro}</p>}
          {storyParagraphs.map((paragraph, index) => (
            <p key={index}>
              {paragraph.includes("true success") ? (
                <>
                  {paragraph.split("true success")[0]}
                  <span className="text-foreground font-medium">
                    true success is not just about performance: it's about alignment and purpose.
                  </span>
                  {paragraph.includes("purpose.") ? paragraph.split("purpose.")[1] : ""}
                </>
              ) : (
                paragraph
              )}
            </p>
          ))}
        </div>

        {/* Credentials */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {credentials.map((item, index) => (
            <div key={index} className="flex flex-col items-center gap-2 text-center">
              <div className="w-11 h-11 rounded-full bg-muted flex items-center justify-center">
                <item.icon className="w-5 h-5 text-foreground/60" />
              </div>
              <span className="text-xs font-medium text-foreground/70">{item.label}</span>
            </div>
          ))}
        </div>

        {/* Philosophy */}
        <div className="text-center">
          <h3 className="text-3xl md:text-4xl font-semibold text-foreground mb-5 tracking-[-0.02em]">
            {content.about_philosophy_title}
          </h3>
          <p className="text-[17px] text-muted-foreground leading-[1.75] mb-6">
            {content.about_philosophy_text}
          </p>
          {content.about_quote && (
            <p className="text-lg text-muted-foreground italic">
              "{content.about_quote}"
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default About;
